import {RequestFormType} from "../const/const"
import {QuickAddItemType} from "../../../quick-add/@types";

const debug= false
// const debug = "addNewFormAction"

export function addNewFormAction(requestFormType:RequestFormType, projectId?: ID) {
    debug && console.log(debug, 'process')

    switch (requestFormType) {
        case RequestFormType.REQUEST: gd.openNew(QuickAddItemType.REQUEST_FORM, {type: RequestFormType.REQUEST, projectId}); break
        case RequestFormType.FORM   : gd.openNew(QuickAddItemType.REQUEST_FORM, {type: RequestFormType.FORM, projectId}); break
    }
}